var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from 'react';
import uniqBy from 'lodash.uniqby';
var modals = [];
var setModals;
var updateModals = function (components) {
    if (setModals) {
        // Don't update ModalManager state unless component is mounted
        setModals(components);
    }
    else {
        modals = __spreadArrays(components);
    }
};
var warn = function (message) {
    if (process.env.NODE_ENV !== 'production') {
        console.warn("[ModalManager] " + message);
    }
};
export var pushModal = function (component, baseZIndex, modalId, replaceExisting) {
    if (baseZIndex === void 0) { baseZIndex = 1300; }
    var existingModal = modalId !== undefined && modals.find(function (modal) { return modal.modalId === modalId; });
    // modal already exists but replaceExisting is false? warn and return
    if (existingModal && !replaceExisting) {
        warn("[ModalManager] You are attempting to push a modal with a modal ID that already exists on the stack! No modal will be added. Use the 'replaceExisting' parameter in pushModal to replace an existing modal ID with a new component. Modal ID: " + modalId);
        return;
    }
    // modal exists and user wants to replace it
    if (existingModal && replaceExisting) {
        var existingModalIdx = modals.findIndex(function (modal) { return modal.modalId === modalId; });
        // replace it at the same array index
        modals = __spreadArrays(modals.slice(0, existingModalIdx), [
            { component: component, modalId: modalId, baseZIndex: baseZIndex }
        ], modals.slice(existingModalIdx + 1));
        updateModals(modals);
        return;
    }
    // modal does not exist, add it to the stack
    modals.push({ component: component, modalId: modalId, baseZIndex: baseZIndex });
    updateModals(__spreadArrays(modals));
};
export var popModal = function (modalId) {
    var modalToPop = modalId !== undefined && modals.find(function (modal) { return modal.modalId === modalId; });
    // id was provided, modal with id not found, warn and return
    if (modalId && !modalToPop) {
        warn("You are trying to pop a modal that does not exist in the stack! Nothing will happen. Modal ID: " + modalId);
        return;
    }
    // id was provided, modal with id found, remove from stack and return
    if (modalToPop) {
        modals = modals.filter(function (modal) { return modal.modalId !== modalId; });
        updateModals(modals);
        return;
    }
    // no id provided, just remove the last element pushed
    modals.pop();
    updateModals(__spreadArrays(modals));
};
export var clearModals = function () {
    modals = [];
    updateModals(modals);
};
export var modalCounts = function () {
    return modals.length;
};
export var modalExists = function (modalId) {
    return modals.find(function (modal) { return modal.modalId === modalId; });
};
export var ModalManager = function () {
    var _a = React.useState(modals), modalStack = _a[0], setModalStack = _a[1];
    setModals = setModalStack;
    var zIndices = uniqBy(modalStack, function (modal) { return modal.baseZIndex; }).map(function (modal) { return modal.baseZIndex; });
    return (React.createElement(React.Fragment, null, zIndices.map(function (zIndex) {
        var modalsAtZindex = modalStack.filter(function (modal) { return modal.baseZIndex === zIndex; });
        return (React.createElement("div", { style: { zIndex: zIndex }, id: "ModalManager-" + zIndex, key: zIndex }, modalsAtZindex.map(function (modal, idx) { return (React.createElement("div", { style: { zIndex: idx }, key: modal.modalId ? modal.modalId : idx }, modal.component)); })));
    })));
};
export default ModalManager;
